import SectionFour from "../Componets/SectionFour"
import Footer from "../Componets/Footer";

import '../styles/style.css'

export default function About() {
    return (
        <>
            <div className="space-in-page" ></div>
            <SectionFour />
            <Footer />
        </>
    );
}
